export enum SAVE_KEYS {
    Version = "hos_version",
    LastUpdatedTimestamp = "hos_last_updated_timestamp",
    ActiveCases = "hos_active_cases",
    MailboxContents = "hos_mail_box_contents",
    MailboxZoomFactor = "hos_mail_box_zoom",
    KnownUrls = "hos_known_urls",
    CRTEffectEnabled = "hos_crt_effect_enabled",
    ShouldAutoFullscreen = "hos_should_auto_fullscreen",
    AuthKey = "hos_auth_key",
    AuthPlatform = "hos_auth_platform",
    SeenFTUTutorial = "hos_seen_ftu_tutorial",
    MusicMuted = "hos_mute_music",
    MuteSFX = "hos_mute_sfx",
    PastCases = "hos_past_cases",
    NumOfSolvedCases = "hos_solved_cases_count",
    NumOfIncorrectDiagnoses = "hos_incorrect_cases_count",
    DocScore = "hos_docscore",
    Achievements = "hos_achievements",
    Use24HrClock = "hos_use_24hr_clock",
    GameMode = "hos_gamemode",
    CharacterCreatorSettings = "hos_portrait_settings",
    DisplayName = "hos_display_name",
    Birthdate = "hos_birthdate",
    Hometown = "hos_hometown",
    Contacts = "hos_contacts",
    SaveSlot0 = "hos_save_slot_0",
    SaveSlot1 = "hos_save_slot_1",
    SaveSlot2 = "hos_save_slot_2",
    Day = "hos_day",
    NarrativeState = "hos_narrative_state",
    CurrentDayTimer = "hos_day_timer",
}
